import isEmpty from 'lodash.isempty';
import get from 'lodash.get';
import actionTypes from '../constants/action-types';
import siteLocalesConstants from '../../site-locales/constants/common';

const blockPreview = (state = {}, action) => {
  if (action.type !== actionTypes.INITIALIZE_BLOCK) return state;
  if (state.id !== action.payload.blockId) return state;

  if (!state.variations) return state;

  const { htmlLocale } = action.payload;

  let hasVariationChanged = false;

  const variations = state.variations.map((variation) => {
    const preview =
      get(state, `previews[${variation.id}][${htmlLocale}]`) ||
      get(state, `previews[${variation.id}][${siteLocalesConstants.DEFAULT_SITE_LOCALE}]`);

    if (isEmpty(preview)) {
      return variation;
    }

    hasVariationChanged = true;

    return {
      ...variation,
      preview,
    };
  });

  if (!hasVariationChanged) return state;

  return {
    ...state,
    variations,
  };
};

export default blockPreview;
